{
	"loading_reservations_text": "Pak even je ontspanmoment, wij halen de reserveringen voor je op.",
	"only_the_most_recent_reservations_shown_text": "Alleen de 50 meest recente reserveringen worden getoond.",
	"homeScreen": "Home",
	"close": "Sluiten",
	"done": "Klaar",
	"delete": "Verwijderen",
	"per_person_short": "p.p.",
	"starting_from_short": "v.a.",
	"book_now": "Reserveren",
	"more_info": "Meer info",
	"next": "Volgende",
	"previous": "Vorige",
	"login_or_register": "Login of registreer",
	"cancel": "Annuleren",
	"are_you_sure_you_want_to_logout": "Weet je zeker dat je wil uitloggen?",
	"continue": "Doorgaan",
	"do_login": "Inloggen",
	"do_register": "Aanmelden",
	"login_with_password": "Inloggen met wachtwoord",
	"login_with_magiclink": "Inloggen met link",
	"madam": "Mevrouw",
	"sir": "Meneer",
	"gender_prefer_not_to_say": "Zeg ik liever niet",
	"go_back": "Ga terug",
	"first_name": "Voornaam",
	"infix_name": "Tussenvoegsel",
	"last_name": "Achternaam",
	"email_address": "E-mailadres",
	"email_address_invalid": "Vul een geldig e-mailadres in",
	"password": "Wachtwoord",
	"password_with_rules": "Wachtwoord (min. 8 tekens)",
	"repeat_password": "Herhaal wachtwoord",
	"show_password": "Wachtwoord tonen",
	"hide_password": "Wachtwoord verbergen",
	"resend": "Opnieuw versturen",
	"you_are_almost_there": "Je bent er bijna...",
	"unknown_error_occurred": "Er is een onbekende fout opgetreden",
	"view": "Bekijken",
	"book": "Reserveren",
	"sendAMessage": "Stuur een bericht",
	"check_your_email_and_click_on_the_link_to_confirm_your_registration": "Controleer je e-mail en klik op de link om jouw aanmelding te bevestigen.",
	"are_you_sure_you_want_to_reset_your_password": "Weet je zeker dat je je wachtwoord wilt resetten?",
	"an_email_is_on_its_way_to_you": "Er is een e-mail naar je onderweg",
	"your_account_must_be_verified_before_you_can_log_in_an_email_has_been_sent_to_you_with_a_verification_link": "Je account moet eerst geverifieerd zijn voordat je kan loggen. Verstuur opnieuw de verificatie link door op onderstaande button te klikken..",
	"click_on_the_link_in_the_email_to_log_in_immediately_didnt_receive_an_email_it_may_take_a_few_minutes_before_you_receive_the_email_also_just_to_be_sure_check_your_junk_mail": "Klik op de link in de e-mail om direct in te loggen. Geen e-mail ontvangen? Het kan enkele minuten duren voordat je de mail ontvangt. Kijk voor de zekerheid ook even in je ongewenste e-mail.",
	"message_category_booking": "Reservering",
	"message_category_news": "Nieuws",
	"show_all": "Toon Alles",
	"messages": "Mijn berichten",
	"message": "Bericht",
	"reply_on_this_message": "Reageer op dit bericht",
	"send": "Verzenden",
	"sendAs": "Dit verzenden als",
	"subject": "Onderwerp",
	"reservation_number_form_title": "Over welke reservering gaat je bericht? (optioneel)",
	"reservation_number": "Reserveringsnummer",
	"something_went_wrong_title": "Er is iets misgegaan...",
	"something_went_wrong_message": "Controleer je internet verbinding en probeer het opnieuw.",
	"too_many_requests": "Te veel pogingen. Probeer het later opnieuw.",
	"try_again": "Opnieuw proberen",
	"thermen_resort_general_form_title": "Over welk resort gaat je bericht?",
	"thermen_resort_general": "Thermen Resort (algemeen)",
	"select_a_thermen_resort": "Selecteer een Thermen Resort",
	"save": "Opslaan",
	"your_adjustment_has_been_processed_in_our_database_it_may_take_up_to_24_hours_for_your_adjustment_to_be_processed": "Je aanpassing is verwerkt in onze administratie. Het kan tot 24 uur duren voordat je aanpassing volledig is verwerkt.",
	"not_available_short": "n.v.t.",
	"video": "Video",
	"response": "Reactie",
	"your_response_has_been_sent": "Je reactie is verzonden",
	"thanks_for_your_message_we_will_contact_you_by_email_as_soon_as_possible": "Bedankt voor je bericht. We nemen zo snel mogelijk contact met je op per mail.",
	"please_note_have_you_requested_a_change_you_will_then_receive_a_new_confirmation_of_your_adjusted_reservation_by_email_from_us_as_soon_as_you_have_received_this_email_this_change_will_also_be_visible_in_the_app_within_an_hour": "Let op: heb jij een wijziging aangevraagd? Dan ontvang je van ons een nieuwe bevestiging van je aangepaste reservering per e-mail. Zodra je deze e-mail hebt ontvangen is deze wijziging binnen een uur ook zichtbaar in de app.",
	"resort_info": "Resort Info",
	"delete_account": "Account verwijderen",
	"are_you_sure_you_want_to_delete_your_account": "Let op! Je staat op het punt je account te verwijderen. Je raakt de toegang tot je account kwijt en je opgebouwde Thermenfans-status komt te vervallen.",
	"current_password": "Huidig wachtwoord",
	"add": "Toevoegen",
	"video_tutorials": "Videohandleidingen",
	"tutorials_title": "Bekijk onze handige videohandleidingen",
	"tutorials_description": "Van 't aanmaken van een Thermen Resorts-account tot het inwisselen van je Thermenfans-voordelen. We hebben korte video's gemaakt om je hierbij te helpen. Heb je nog vragen na het bekijken van deze video's? Bekijk dan onze veelgestelde vragen.",
	"which_reservation_are_you_reporting_about_question": "Over welke reservering gaat je bericht?",
	"optional": "optioneel",
	"general_thermen_resorts": "Algemeen/Thermen Resorts",
	"ignore": "Negeren",
	"update": "Update",
	"swimwear_day": "Badkledingdag",
	"filter_swimwear_days": "Filter op badkledingdagen",
	"app_version": "App versie: {{appVersion}} ({{buildVersion}})",
	"add_reservation_manually_description": "Staat je reservering er niet tussen? Dan kan je hem handmatig toevoegen met je reserveringsnummer die je ontvangen hebt per e-mail.",
	"enter_manually": "Handmatig toevoegen",
	"add_reservation_manually": "Reservering handmatig toevoegen",
	"fill_in_all_required_fields": "Vul alle verplichte velden in.",
	"onboarding": {
		"step1": {
			"header": "Stap in onze wereld van ontspanning",
			"description": "Reserveren, sparen én (thuis) genieten."
		},
		"step2": {
			"header": "Ontdek welke voordelen er op jou wachten",
			"description": "Persoonlijke aanbiedingen en voordelen voor onze échte Thermenfans."
		},
		"step3": {
			"header": "Eenvoudig boeken en je reserveringen beheren ",
			"description": "Alles op één plek."
		},
		"step4": {
			"header": "Fijne ontspanmomenten",
			"description": "Onze Thermenexperts helpen jou met praktische tips, inspiratie en oefeningen."
		}
	},
	"login": {
		"overlay_tagline": "Ontdek jouw voordeel",
		"step1": {
			"header": "Inloggen of aanmelden",
			"description": "Wij kijken of je al een account bij ons hebt."
		},
		"step2": {
			"header": "Fijn dat je er bent!"
		},
		"step3": {
			"header": "Inloggen met wachtwoord"
		},
		"forgot_password_link": "Wachtwoord vergeten?",
		"email_password_combination_invalid_error": "De combinatie van dit e-mailadres en wachtwoord is niet bij ons bekend.",
		"magiclink_invalid_error": "Deze magiclink lijkt niet meer geldig te zijn. Probeer het nogmaals."
	},
	"register": {
		"step2": {
			"header": "Account aanmaken",
			"description": "We leren je graag beter kennen, vul je gegevens in:"
		}
	},
	"Preferences": {
		"upcomingReservations": "Aankomende reserveringen",
		"language": "Taal",
		"english": "Engels",
		"german": "Duits",
		"spanish": "Spaans",
		"russian": "Russisch"
	},
	"dashboard": {
		"prepare": {
			"title": "Bereid je optimaal voor"
		}
	},
	"resort": {
		"contact": "Contact",
		"routeDescription": "Routebeschrijving"
	},
	"home": {
		"upcomingReservations": "Aankomende reserveringen",
		"title": "Bereid je optimaal voor",
		"completeStay": "Maak je verblijf compleet",
		"discover": "Ontdek",
		"discoverMore": "Ontdek meer",
		"easyBooking": "Maak eenvoudig een reservering",
		"comeResorts": "Kom langs in één van onze resorts",
		"manageBooking": "Beheer je reservering",
		"arrangeApp": "Regel alles via de app",
		"featured": "Uitgelicht",
		"featuredSubtitle": "Van onze resorts",
		"arrangement": "arrangement",
		"mostBooked": "Meest geboekt",
		"discoverOurThermenResorts": "Ontdek onze Thermen Resorts",
		"reserveVisit": "Reserveer je bezoek",
		"reserve": "Reserveer",
		"viewReservation": "Bekijken",
		"showBarcode": "Toon Barcode"
	},
	"tabs": {
		"home": "Home",
		"booking": "Reserveren",
		"thermenfans": "Thermenfans",
		"relaxation": "Ontspanning",
		"bathCard": "Badenkaart",
		"account": "Account"
	},
	"headers": {
		"account": "Mijn account"
	},
	"bathcard": {
		"url": "https://thermenresorts.nl/badenkaarten",
		"addBathcard": "Bestaande kaart koppelen",
		"buyBathcard": "Badenkaart kopen",
		"leaveAppDescription": "We sturen je door naar de website om je badenkaart te kopen.",
		"balanceDelayTooltip": "Het kan even duren voor het actuele saldo van de badenkaart wordt bijgewerkt.",
		"areYouSureDeleteBathcard": "Weet je zeker dat je deze kaart wil verwijderen?",
		"areYouSureUnlinkBathcard": "Deze badenkaart heeft nog een openstaand tegoed, weet je zeker dat je deze wil ontkoppelen?",
		"cards": "Badenkaarten",
		"loading": "Badenkaart wordt geladen",
		"cardSummary": "Je hebt nog <strong>{{visits}}</strong> tot {{date}} bij {{workspace}}",
		"cardSummaryWithoutExpiry": "Je hebt nog <strong>{{visits}}</strong> bij {{workspace}}",
		"visitOne": "1 bezoek",
		"visitsOther": "{{count}} bezoeken",
		"reserve": "Reserveren",
		"noCardHeading": "Nog geen badenkaart?",
		"extraCardHeading": "Extra badenkaart?",
		"acquireIntro": "Geniet extra voordelig bij jouw favoriete thermen resort met een 10- of 20-badenkaart.",
		"linkCard": "Kaart koppelen",
		"buyCard": "Kaart kopen",
		"uspsTitle": "Jouw badenkaart voordelen",
		"yourBathcard": "Jouw badenkaart",
		"view": "Bekijken",
		"buyNewCard": "Koop nieuwe badenkaart",
		"removeThisCard": "Verwijder deze kaart",
		"unlink": "Ontkoppelen",
		"unlinkThisCard": "Ontkoppel deze kaart"
	},
	"loyalty": {
		"selectResort": "Selecteer je resort",
		"sale": "Korting",
		"redeem": "Verzilveren",
		"moreInfo": "Meer info",
		"discoverMyBenefits": "Ontdek je voordelen",
		"download_voucher": "Download voucher",
		"benefits": "Jouw Thermenfan voordelen",
		"personalBenefitsWithCount": "Jouw {{count}} persoonlijke voordelen",
		"benefitsSubtitle": "Van deze maand",
		"useBenefit": "Gebruik",
		"benefitUsed": "Gebruikt",
		"useThisBenefit": "Gebruik dit voordeel",
		"youUsedThisBenefit": "Je hebt dit voordeel gebruikt"
	},
	"account": {
		"upcomingReservations": "Aankomende reserveringen",
		"pastReservations": "Eerdere reserveringen",
		"noUpcomingReservations": "Geen aankomende reserveringen gevonden.",
		"noPastReservations": "Geen eerdere reserveringen gevonden.",
		"myDetails": "Mijn gegevens",
		"mail": "mail",
		"changePersonalDetails": "Persoonlijke gegevens",
		"changeAdressDetails": "Adresgegevens",
		"closeModal": "Sluiten",
		"resetConfirm": "Weet je zeker dat je je wachtwoord wilt resetten?",
		"resetConfirmed": "We hebben je wachtwoord-resetlink per e-mail verstuurd!",
		"resetDescription": "Er zal een e-mail verstuurd worden naar jouw email indien je op reset wachtwoord drukt. In deze mail zal een link staan om een nieuw wachtwoord aan te vragen.",
		"resetDescriptionSuccess": "Klik op de link in de e-mail om je wachtwoord te wijzigen. Geen e-mail ontvangen? Het kan enkele minuten duren voordat je de mail ontvangt. Kijk voor de zekerheid ook even in je ongewenste mail.",
		"resetPassword": "Wijzig wachtwoord",
		"attention": "Let op!",
		"deleteWarning": "Je account en thermenfans-status worden hierbij verwijderd.",
		"myPreferences": "Mijn voorkeuren",
		"preferences": {
			"notifications": "Notificaties",
			"emails": "E-mails",
			"preferredLanguage": "Voorkeurstaal",
			"newsletterDetail": "Niets meer missen? Wees als een van de eersten op de hoogte van ons laatste nieuws. Jij bepaalt zelf welke mails je ontvangt.",
			"languageDetail": "Ontspannen op jouw manier. In jouw taal. Selecteer jouw taalvoorkeur."
		},
		"emailDescriptionPreferences": "Zelf bepalen welk nieuws je van ons ontvangt? Pas je voorkeuren aan en ontvang elke week nieuws over de door jou geselecteerde onderwerpen.",
		"sendAMessage": "Contact opnemen",
		"appExplanation": "Uitleg over de app",
		"logout": "Uitloggen"
	},
	"resetpassword": {
		"closeModal": "Sluiten",
		"resetConfirm": "Weet je zeker dat je je wachtwoord wilt resetten?",
		"resetConfirmed": "We hebben je wachtwoord-resetlink per e-mail verstuurd!",
		"resetDescription": "Er zal een e-mail verstuurd worden naar jouw email indien je op reset wachtwoord drukt. In deze mail zal een link staan om een nieuw wachtwoord aan te vragen.",
		"resetDescriptionSuccess": "Klik op de link in de e-mail om je wachtwoord te wijzigen. Geen e-mail ontvangen? Het kan enkele minuten duren voordat je de mail ontvangt. Kijk voor de zekerheid ook even in je ongewenste mail.",
		"resetPassword": "Reset wachtwoord"
	},
	"reservation": {
		"bookAgain": "Boek opnieuw",
		"viewReservation": "Bekijk reservering",
		"id": "Reserverings ID",
		"booking": "Boeking",
		"included": "Inclusief",
		"location": "Locatie",
		"price": "Prijs",
		"questionOrChange": "Heb je een vraag of wil je jouw reservering wijzigen?",
		"addPreferencesHeading": "Geef je voorkeuren door!",
		"addPreferences": "Voorkeuren doorgeven",
		"addPreferencesText": "Een onvergetelijk verblijf vol luxe, ontspanning en verwennerij wacht binnenkort op jou.",
		"sendAMessage": "Stuur ons een bericht",
		"callUs": "Bel ons op",
		"personCount": "persoon",
		"personCounts": "personen",
		"showBarcode": "Toon Barcode",
		"yourReservation": "Jouw reservering",
		"unknown": "Onbekend"
	},
	"dialog": {
		"barcode": "Barcode"
	},
	"settings": {
		"update_available": "Update beschikbaar",
		"update_available_description": "Er is een update van de Thermen Resorts app beschikbaar.",
		"update_available_mandatory": "Update vereist",
		"update_available_mandatory_description": "De Thermen Resorts app heeft een update nodig.",
		"update_available_version_text": "Je zit momenteel op {{currentVersion}}. Versie {{newVersion}} is beschikbaar."
	},
	"select_resort": "Selecteer een Thermen Resort",
	"select_resort_error": "Selecteer een resort waar je vraag over gaat",
	"enter_subject": "Vul een onderwerp in",
	"enter_message": "Vul een bericht in",
	"url_could_not_be_opened_title": "URL openen mislukt",
	"url_could_not_be_opened_description": "Het is niet gelukt om de URL te openen. Controleer of er een externe browser geïnstalleerd is.",
	"copy_url": "Kopiëer url",
	"okay": "Oké",
	"readMore": "Lees meer",
	"check_your_advantages": "Jouw voordelen",
	"exclusive_access_to_personal_advantages": "Exclusieve persoonlijke voordelen",
	"easy_way_to_manage_your_reservations": "Eenvoudig reserveringen beheren",
	"enjoy_relaxation_at_home": "Geniet van ontspanning bij je thuis",
	"duration_minutes": "{{minutes}} min",
	"exercise_of_the_day": "Oefening van de dag",
	"play_video": "Video afspelen",
	"stop_video": "Video stoppen",
	"unavailable_in_active_locale_message": "Let op: u wordt doorgestuurd naar onze Engelstalige website.",
	"reserve": {
		"url": "https://www.thermenresorts.nl/reserveren",
		"withLoyalty": "Met Thermenfans-voordelen",
		"withLoyaltyDescription": "Gebruik jouw status en voordelen",
		"withBathCard": "Met je badenkaart",
		"withBathCardDescription": "Koop of koppel je badenkaart",
		"standard": "Standaard reservering",
		"standardDescription": "Via de website, altijd actuele beschikbaarheid",
		"leaveAppDescription": "We sturen je door naar de website om de actuele beschikbaarheid te bekijken en te reserveren."
	},
	"leaveApp": {
		"title": "Je verlaat de app",
		"description": "We sturen je door naar een website buiten de app.",
		"confirm": "Doorgaan naar de website"
	}
}
